import React, { Component } from 'react';
import { isEmpty } from '../../../Common/Common';
import pattern_list_icon from '../../../../Images/Daikin_Images/image/Data.png';

import Top_Bar from '../../../Part_Sample/Top_Bar';
import Dropdown from '../../../Part_Sample/Dropdown';
import Button from '../../../Part_Sample/Button';

import Repeat from '../Components/Repeat';
import Special_Calendar from '../Components/Special_Calendar';

export default class Schedule_Step4_Execute_Days extends Component {
	constructor(props) {
		super(props);

		let wd = [];
		let spd = [];
		let drop_down_list = [];
		let selected_calendar_id = '';

		// Program
		this.program = {};
		if (this.props.param.program != null) {
			this.program = JSON.parse(JSON.stringify(this.props.param.program));
		}

		// Check if action is blank 
		if (isEmpty(this.program.action)) {
			this.program.action = {};
		} else {
			let patternList = this.props.param.schedule.pattern;
			let program = this.program.action;

			//Check if pattern exist in patternList
			Object.keys(this.program.action).map(function(key, index) {
				//Delete pattern in this.program.action if pattern does not exist in patternList
				if(!patternList.hasOwnProperty(key)) {
					delete program[key];
				}
			});
		}

		let check_existing_dow = [];
		if (!isEmpty(this.program)) {
			if (!isEmpty(this.program.action)) {
				// Check existing dow
				for (let pattern_id in this.program.action) {
					if (pattern_id != this.props.param.pattern_id && pattern_id != this.props.param.original_pattern_id) {
						let exec_dow = this.program.action[pattern_id].exec_dow;
						check_existing_dow = [...check_existing_dow, ...exec_dow];
					}
				}
				// Repeat Days of week AND Special Day Calendar
				if (this.props.param.pattern_id != null) {
					if (this.props.param.original_pattern_id == '' || this.props.param.original_pattern_id == this.props.param.pattern_id) {
						if (this.program.action[this.props.param.pattern_id] != null) {
							if (this.program.action[this.props.param.pattern_id].exec_dow != null) {
								wd = this.program.action[this.props.param.pattern_id].exec_dow;
							}
							if (this.program.action[this.props.param.pattern_id].exec_cal != null) {
								spd = this.program.action[this.props.param.pattern_id].exec_cal;
								// Currently only 1 special day calendar can be selected (new requirement)
								if (spd.length > 0) selected_calendar_id = spd[0];

								//Kaiwei 20210401 Check if calendar has been deleted
								if (isEmpty(this.props.param.schedule.calendar[selected_calendar_id])) selected_calendar_id = '';
							}
						}
					}
				}
			}
		}

		let days_of_week = [
			{
				key: 0,
				display: this.props.receiver.getString('s_sun'),
				is_checked: wd.includes(0) ? true : false,
				is_disabled: check_existing_dow.includes(0) ? true : false,
			},
			{
				key: 1,
				display: this.props.receiver.getString('s_mon'),
				is_checked: wd.includes(1) ? true : false,
				is_disabled: check_existing_dow.includes(1) ? true : false,
			},
			{
				key: 2,
				display: this.props.receiver.getString('s_tue'),
				is_checked: wd.includes(2) ? true : false,
				is_disabled: check_existing_dow.includes(2) ? true : false,
			},
			{
				key: 3,
				display: this.props.receiver.getString('s_wed'),
				is_checked: wd.includes(3) ? true : false,
				is_disabled: check_existing_dow.includes(3) ? true : false,
			},
			{
				key: 4,
				display: this.props.receiver.getString('s_thu'),
				is_checked: wd.includes(4) ? true : false,
				is_disabled: check_existing_dow.includes(4) ? true : false,
			},
			{
				key: 5,
				display: this.props.receiver.getString('s_fri'),
				is_checked: wd.includes(5) ? true : false,
				is_disabled: check_existing_dow.includes(5) ? true : false,
			},
			{
				key: 6,
				display: this.props.receiver.getString('s_sat'),
				is_checked: wd.includes(6) ? true : false,
				is_disabled: check_existing_dow.includes(6) ? true : false,
			}
		];

		this.state = {
			days_of_week: days_of_week,
			selected_calendar_id: selected_calendar_id,
		}
	}

	handlePrevious = () => {
		let param = this.props.param;
		//if(param.original_from != null) param.from = param.original_from;
		this.props.content_handler('Schedule_Step3_Pattern', param);
	}

	handleChangeDaysOfWeek = (key) => {
		let list = [...this.state.days_of_week];

		for (let i in list) {
			if (list[i].key == key) {
				list[i].is_checked = !list[i].is_checked;
				this.setState({
					days_of_week: list,
				});
				break;
			}
		}
	}

	handleChangeSpecialCalendar = (key) => {
		this.setState({ selected_calendar_id: key });
	}

	handleRegister = () => {
		let dow = [];
		for (let j in this.state.days_of_week) {
			if (this.state.days_of_week[j].is_checked) {
				dow.push(this.state.days_of_week[j].key);
			}
		}

		if (dow.length < 1 && this.state.selected_calendar_id == '') {
			window.app.showToast(this.props.receiver.getString('no_repeat_date'), 3000);
			return;
		}

		if (this.props.param.original_pattern_id != '' && this.props.param.original_pattern_id != this.props.param.pattern_id) {
			delete this.program.action[this.props.param.original_pattern_id];
		}

		let cal_list = [];
		if (this.state.selected_calendar_id != '') cal_list.push(this.state.selected_calendar_id);

		let action = {};
		if (this.program.action == null) {
			this.program.action = {}
		}
		this.program.action[this.props.param.pattern_id] = {};
		this.program.action[this.props.param.pattern_id].exec_dow = dow;
		this.program.action[this.props.param.pattern_id].exec_cal = cal_list;

		let param = this.props.param;
		param.program = this.program;

		this.props.content_handler('Schedule_Office_Summary', param);
	}

	handleCalendarList = (cal_id) => {
		let dow = [];
		for (let j in this.state.days_of_week) {
			if (this.state.days_of_week[j].is_checked) {
				dow.push(this.state.days_of_week[j].key);
			}
		}

		let cal_list = [];
		if (this.state.selected_calendar_id != '') cal_list.push(this.state.selected_calendar_id);

		let action = {};
		if (this.program.action == null) {
			this.program.action = {}
		}
		this.program.action[this.props.param.pattern_id] = {};
		this.program.action[this.props.param.pattern_id].exec_dow = dow;
		this.program.action[this.props.param.pattern_id].exec_cal = cal_list;

		let param = this.props.param;
		param.program = this.program;
		param.calendar_id = cal_id;
		param.from = 'Schedule_Step3_Pattern';
		this.props.content_handler('Add_Edit_Calendar', param);
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let dropdown_left_margin = 80;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('sel_exec_days')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ height: this.props.height - 120, overflow: 'auto' }}>
						<div style={{ marginLeft: 20, textAlign: 'left', marginBottom: 20 }}>
							<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('schedule_step4_instr')}</span>
						</div>
						<div style={{ marginBottom: 20 }}>
							<Repeat
								receiver={this.props.receiver}
								days_of_week={this.state.days_of_week}
								handleChangeDaysOfWeek={this.handleChangeDaysOfWeek}
								repeatKeyword={'repeat'}
							/>
							<div className='noScrollBar' style={{ marginTop: 20, height: this.props.height - 280, overflow: 'auto' }}>
								<Special_Calendar
									receiver={this.props.receiver}
									selected_calendar_id={this.state.selected_calendar_id}
									calendar_list={this.props.param.schedule.calendar}
									handleCalendarList={this.handleCalendarList}
									handleChangeSpecialCalendar={this.handleChangeSpecialCalendar}
									width={this.props.width}
									height={this.props.height}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}